"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeSectionItemByWidgetRefHandler = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var layoutSelectors_1 = require("../../store/layout/layoutSelectors");
var removeSectionItemHandler_1 = require("./removeSectionItemHandler");
var general_1 = require("../../events/general");
var sdk_model_1 = require("@gooddata/sdk-model");
function removeSectionItemByWidgetRefHandler(ctx, cmd) {
    var widgetCoordinates, e_1;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, effects_1.select(layoutSelectors_1.selectWidgetCoordinatesByRef(cmd.payload.widgetRef))];
            case 1:
                widgetCoordinates = _a.sent();
                return [3 /*break*/, 3];
            case 2:
                e_1 = _a.sent();
                throw general_1.invalidArgumentsProvided(ctx, cmd, "Can't get widget coordinates for widget ref: " + sdk_model_1.objRefToString(cmd.payload.widgetRef) + ", " + e_1.message);
            case 3: return [4 /*yield*/, effects_1.call(removeSectionItemHandler_1.removeSectionItemSaga, ctx, {
                    correlationId: cmd.correlationId,
                    payload: tslib_1.__assign(tslib_1.__assign({}, widgetCoordinates), { eager: cmd.payload.eager, stashIdentifier: cmd.payload.stashIdentifier }),
                }, cmd)];
            case 4: return [2 /*return*/, _a.sent()];
        }
    });
}
exports.removeSectionItemByWidgetRefHandler = removeSectionItemByWidgetRefHandler;
//# sourceMappingURL=removeSectionItemByWidgetRefHandler.js.map